import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import { useNavigate, Link } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({});
  const desktopNavRef = useRef(null);

  const toggleSubmenu = (index) => {
    setExpandedMenus((prev) => {
      const isCurrentlyOpen = prev[index];
      const newState = {};
      Object.keys(prev).forEach((key) => (newState[key] = false));
      if (!isCurrentlyOpen) newState[index] = true;
      return newState;
    });
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setExpandedMenus({});
  };

  const closeDesktopSubmenus = () => {
    setExpandedMenus({});
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (desktopNavRef.current && !desktopNavRef.current.contains(e.target)) {
        closeDesktopSubmenus();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    $(window).scroll(() => {
      $(".sticky-wrapper").toggleClass("sticky", $(window).scrollTop() > 500);
    });
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setIsMobileMenuOpen(false);
        setExpandedMenus({});
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems = [
    { label: "Home", to: "/" },
    {
      label: "Properties",
      children: [
        { label: "Available Estates", to: "/top-estates" },
        { label: "Diaspora Buyers Guide", to: "/diaspora-guide" },
      ],
    },
    { label: "Services & Engineering", to: "/services" },
    {
      label: "About Us",
      children: [
        { label: "About Us", to: "/about" },
        { label: "Careers at Sagama", to: "/careers" },
      ],
    },
    {
      label: "Resources",
      children: [
        { label: "Blog & News", to: "/blog" },
        { label: "FAQs", to: "/faq" },
      ],
    },
    { label: "Contact Us", to: "/contact" },
  ];

  return (
    <>
      <style>{`
        .top-bar {
          background-color: #0a1a3d;
          color: rgba(255,255,255,0.85);
          font-size: 0.7rem;
          padding: 5px 0;
          line-height: 1.3;
        }
        .top-bar a { color: inherit; text-decoration: none; font-weight: 500; }
        .top-bar .social-icon { color: rgba(255,255,255,0.8); margin-left: 10px; font-size: 0.8rem; transition: color 0.2s; }
        .top-bar .social-icon:hover { color: #e86b24; }

        .header-logo img { max-width: 80px; height: auto; }
        .mobile-logo img { max-width: 70px; }
        @media (max-width: 991px) { .header-logo img { max-width: 65px; } }

        /* ========= Desktop Menu ========= */
        .main-menu ul {
          list-style: none; margin: 0; padding: 0; display: flex; flex-wrap: nowrap; align-items: center;
        }
        .main-menu li { position: relative; }

        .main-menu .parent-label {
          display: inline-flex; align-items: center; gap: 6px;
          cursor: pointer; color: #0a1a3d; font-size: 0.75rem; font-weight: 500;
          padding: 6px 10px; white-space: nowrap; text-transform: none;
          transition: color 0.3s, background 0.2s; border-radius: 6px;
        }
        .main-menu .parent-label:hover { color: #e86b24; background: rgba(232,107,36,0.05); }
        .main-menu .parent-label.open { color: #e86b24; background: rgba(232,107,36,0.08); }

        .main-menu .toggle-icon {
          font-size: 1rem; font-weight: bold; width: 18px; text-align: center; transition: none;
        }

        /* Desktop dropdown – vertical, visible, same font size as main links */
        .desktop-submenu {
          position: absolute; top: calc(100% + 5px); left: 0;
          background: #fff; border-radius: 12px; box-shadow: 0 15px 30px rgba(0,0,0,0.1);
          min-width: 210px; padding: 8px 0;
          opacity: 0; visibility: hidden; transform: translateY(10px);
          transition: opacity 0.3s, visibility 0.3s, transform 0.3s;
          z-index: 999;
          display: block !important;
        }
        .desktop-submenu.open { opacity: 1; visibility: visible; transform: translateY(0); }
        .desktop-submenu li { display: block; margin: 0; width: 100%; }
        .desktop-submenu a {
          display: block; padding: 8px 20px; color: #333 !important; font-size: 0.75rem !important;   /* same as main links */
          text-decoration: none; white-space: nowrap;
          transition: background 0.2s, color 0.2s, padding-left 0.2s;
          border-left: 3px solid transparent;
        }
        .desktop-submenu a:hover {
          background: #f9f9f9; color: #e86b24 !important; padding-left: 25px; border-left: 3px solid #e86b24;
        }

        .main-menu .simple-link {
          font-size: 0.75rem !important; font-weight: 500 !important; padding: 6px 10px !important;
          text-transform: none !important; color: #0a1a3d !important; text-decoration: none !important;
          white-space: nowrap; border-radius: 6px;
          transition: color 0.3s, background 0.2s;
        }
        .main-menu .simple-link:hover { color: #e86b24 !important; background: rgba(232,107,36,0.05); }

        .whatsapp-circle {
          display: inline-flex; align-items: center; justify-content: center;
          width: 36px; height: 36px; background: rgba(255,255,255,0.15); border-radius: 50%;
          transition: background 0.3s;
        }
        .whatsapp-circle:hover { background: rgba(255,255,255,0.25); }
        .whatsapp-circle img { width: 20px; height: 20px; }

        .btn-inspection {
          background: linear-gradient(135deg, #e86b24, #d2551a); color: white; font-weight: 700;
          padding: 10px 20px; border-radius: 50px; font-size: 0.82rem; border: none;
          letter-spacing: 0.5px; box-shadow: 0 3px 10px rgba(232,107,36,0.35);
          transition: all 0.3s ease; white-space: nowrap;
        }
        .btn-inspection:hover {
          transform: translateY(-2px); box-shadow: 0 6px 16px rgba(232,107,36,0.5);
          background: linear-gradient(135deg, #d2551a, #b8430e);
        }

        .menu-area .row { flex-wrap: nowrap; }
        .nav-container { display: flex; justify-content: flex-start; flex-grow: 1; margin-left: 15px; }

        @media (max-width: 1200px) {
          .main-menu .parent-label { font-size: 0.68rem !important; padding: 5px 8px !important; }
          .main-menu .simple-link { font-size: 0.68rem !important; padding: 5px 8px !important; }
          .btn-inspection { padding: 8px 16px; font-size: 0.75rem; }
          .desktop-submenu a { font-size: 0.68rem !important; }
        }

        /* ========= Mobile Menu ========= */
        .th-mobile-menu .parent-label {
          display: inline-flex; align-items: center; justify-content: space-between; width: 100%;
          cursor: pointer; color: #000 !important; padding: 10px 0; font-weight: 500;
          transition: color 0.2s, background 0.2s;
        }
        .th-mobile-menu .parent-label:hover { color: #e86b24 !important; background: rgba(0,0,0,0.02); }
        .th-mobile-menu .parent-label .toggle-icon {
          font-size: 1.2rem; font-weight: bold; margin-left: 5px; width: 24px; text-align: center;
          color: #000 !important; transition: none;
        }
        .th-mobile-menu .parent-label:hover .toggle-icon { color: #e86b24 !important; }
        .th-mobile-menu .sub-menu {
          max-height: 0; opacity: 0; overflow: hidden;
          transition: max-height 0.4s ease, opacity 0.3s ease;
          list-style: none; padding-left: 20px; margin: 0;
        }
        .th-mobile-menu .sub-menu.sub-menu-open { max-height: 500px; opacity: 1; }
        .th-mobile-menu a {
          color: #000 !important;
          transition: color 0.2s, background 0.2s, padding-left 0.2s;
          display: inline-block; width: 100%; padding: 8px 0;
        }
        .th-mobile-menu a:hover {
          color: #e86b24 !important;
          background: rgba(0,0,0,0.03); padding-left: 8px; border-radius: 4px;
        }
        .th-mobile-menu .sub-menu a { color: #333 !important; }
        .th-mobile-menu .sub-menu a:hover { color: #e86b24 !important; }
      `}</style>

      {/* ====== MOBILE MENU ====== */}
      <div
        className={`th-menu-wrapper${isMobileMenuOpen ? " th-body-visible" : ""}`}
      >
        <div className="th-menu-area text-center">
          <button className="th-menu-toggle" onClick={closeMobileMenu}>
            <i className="fal fa-times" />
          </button>
          <div className="mobile-logo">
            <Link to="/" onClick={closeMobileMenu}>
              <img src="/assets/img/logo.png" alt="Sagama" />
            </Link>
          </div>
          <div className="th-mobile-menu">
            <ul>
              {menuItems.map((item, idx) => {
                if (!item.children) {
                  return (
                    <li key={idx}>
                      <Link to={item.to} onClick={closeMobileMenu}>
                        {item.label}
                      </Link>
                    </li>
                  );
                }
                return (
                  <li className="menu-item-has-children" key={idx}>
                    <span
                      className={`parent-label${expandedMenus[idx] ? " open" : ""}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSubmenu(idx);
                      }}
                    >
                      {item.label}
                      <span className="toggle-icon">
                        {expandedMenus[idx] ? "−" : "+"}
                      </span>
                    </span>
                    <ul
                      className={`sub-menu${expandedMenus[idx] ? " sub-menu-open" : ""}`}
                    >
                      {item.children.map((child, childIdx) => (
                        <li key={childIdx}>
                          <Link to={child.to} onClick={closeMobileMenu}>
                            {child.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="mt-3">
            <button
              className="btn-inspection"
              onClick={() => {
                navigate("/book-inspection");
                closeMobileMenu();
              }}
            >
              Book an Inspection <i className="fas fa-arrow-right ms-1" />
            </button>
          </div>
        </div>
      </div>

      {/* ====== DESKTOP HEADER ====== */}
      <header className="th-header header-layout-default">
        <div className="top-bar">
          <div className="container th-container">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="d-flex flex-wrap align-items-center gap-2 gap-sm-3">
                <span className="d-flex align-items-center">
                  <i className="far fa-phone me-1" />
                  <Link to="tel:07055558942">07055558942</Link>
                </span>
                <span className="d-none d-sm-flex align-items-center">
                  <i className="far fa-envelope me-1" />
                  <Link to="mailto:info@sagamahomes.com">
                    info@sagamahomes.com
                  </Link>
                </span>
                <span className="d-flex align-items-center">
                  <i className="far fa-location-dot me-1" />
                  <span className="d-none d-sm-inline">Kado Estate, Abuja</span>
                  <span className="d-sm-none">Abuja</span>
                </span>
              </div>
              <div className="d-none d-lg-flex align-items-center">
                <span className="me-2">Follow:</span>
                <Link
                  to="https://www.facebook.com/sagamahomes"
                  className="social-icon"
                >
                  <i className="fab fa-facebook-f" />
                </Link>
                <Link
                  to="https://www.twitter.com/sagamahomes/"
                  className="social-icon"
                >
                  <i className="fab fa-twitter" />
                </Link>
                <Link
                  to="https://www.linkedin.com/company/sagamahomes/"
                  className="social-icon"
                >
                  <i className="fab fa-linkedin-in" />
                </Link>
                <Link
                  to="https://www.youtube.com/@SagamaHomes"
                  className="social-icon"
                >
                  <i className="fab fa-youtube" />
                </Link>
                <Link
                  to="https://www.instagram.com/sagamahomes/"
                  className="social-icon"
                >
                  <i className="fab fa-instagram" />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="sticky-wrapper">
          <div className="menu-area">
            <div className="container th-container">
              <div className="row align-items-center flex-nowrap">
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to="/">
                      <img src="/assets/img/logo.png" alt="Sagama" />
                    </Link>
                  </div>
                </div>

                <div
                  className="col nav-container d-none d-lg-flex"
                  ref={desktopNavRef}
                >
                  <nav className="main-menu">
                    <ul>
                      {menuItems.map((item, idx) => {
                        if (!item.children) {
                          return (
                            <li key={idx}>
                              <Link to={item.to} className="simple-link">
                                {item.label}
                              </Link>
                            </li>
                          );
                        }
                        return (
                          <li className="menu-item-has-children" key={idx}>
                            <span
                              className={`parent-label${expandedMenus[idx] ? " open" : ""}`}
                              onClick={() => toggleSubmenu(idx)}
                            >
                              {item.label}
                              <span className="toggle-icon">
                                {expandedMenus[idx] ? "−" : "+"}
                              </span>
                            </span>
                            <ul
                              className={`desktop-submenu${expandedMenus[idx] ? " open" : ""}`}
                            >
                              {item.children.map((child, childIdx) => (
                                <li key={childIdx}>
                                  <Link
                                    to={child.to}
                                    onClick={closeDesktopSubmenus}
                                  >
                                    {child.label}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      })}
                    </ul>
                  </nav>
                </div>

                <div className="col-auto d-none d-xl-flex align-items-center gap-3">
                  <Link
                    to="https://wa.me/23407055558942"
                    className="whatsapp-circle"
                    aria-label="Chat on WhatsApp"
                  >
                    <img src="/assets/img/main/whatsapp.png" alt="WhatsApp" />
                  </Link>
                  <button
                    className="btn-inspection"
                    onClick={() => {
                      navigate("/contact");
                      // Wait for navigation to complete, then scroll to the form
                      setTimeout(() => {
                        document
                          .getElementById("send-message-form")
                          ?.scrollIntoView({ behavior: "smooth" });
                      }, 200);
                    }}
                  >
                    Book an Inspection <i className="fas fa-arrow-right ms-1" />
                  </button>
                </div>

                <div className="col-auto d-lg-none ms-auto">
                  <button
                    type="button"
                    className="th-menu-toggle"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  >
                    <i className="far fa-bars" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
